mutation createHifoCascadePitchMaterial(
  $hifoCascadePitchId: ID!
  $name: String
  $url: String
) {
  createHifoCascadePitchMaterial(
    input: { hifoCascadePitchId: $hifoCascadePitchId, name: $name, url: $url }
  ) {
    pitchMaterial {
      id
      name
      url
      createdAt
    }
  }
}
